import React, { useState, useEffect } from 'react';
import Message from './Message';
import NewMessageInput from './NewMessageInput';
import styles from '../../styles/Roommates/GroupChat.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const GroupChat = ({ groupId, userId }) => {
  const [messages, setMessages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  
	useEffect(() => {
	  const fetchMessages = async () => {
		const res = await fetch(`${API_BASE_URL}/roommates/group/${groupId}/chat`);
		const data = await res.json();

		const formattedMessages = data.map(msg => ({
		  sender: msg.SenderEmail ? msg.SenderEmail.split('@')[0] : "You",
		  content: msg.Message,
		  timestamp: new Date(msg.SentAt).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' }),
		  senderUserId: msg.SenderUserID,
		}));

		setMessages(formattedMessages);
	  };

	  fetchMessages();
	}, [groupId]);


  const handleSendMessage = async (content) => {
    const newMessage = {
      senderUserId: userId,
      senderEmail: null,
      message: content,
    };

    await fetch(`${API_BASE_URL}/roommates/group/${groupId}/chat`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newMessage),
    });

    setMessages([...messages, {
      sender: "You",
      content,
      timestamp: new Date().toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' }),
    }]);
  };

  return (
    <div className={styles.chatContainer}>
      <h3 className={styles.collapsibleHeader} onClick={() => setIsOpen(!isOpen)}>
        Group Chat {isOpen ? '▴' : '▾'}
      </h3>

      {isOpen && (
        <>
          <div className={styles.messagesList}>
            {messages.length === 0 ? (
              <div className={styles.noMessages}>Start the chat!</div>
            ) : (
              messages.map((msg, idx) => (
                <Message key={idx} message={msg} isOwn={msg.senderUserId === userId || msg.sender === "You"} />
              ))
            )}
          </div>
          <NewMessageInput onSend={handleSendMessage} />
        </>
      )}
    </div>
  );
};

export default GroupChat;
